import { AdminType, APIGet, APIPost, APIUrl } from "api/protocols";
import { CancelToken } from "axios";
import { ITeeTime } from "redux/reducers/models/teetime";

export interface IPostLotteryRequestParams {
    lottery_id: number;
    facility_id: number;
    customer_id: number;
    customer_id_one: number;
    customer_id_two: number;
    customer_id_three: number;
    customer_id_four: number;
    start_time_preference_window: number;
    holes: number;
    quantity: number;
    start_time_preference_one: string;
    start_time_preference_two: string;
    start_time_preference_three: string;
}

export async function CustomerGetLottery(
  params: {id: number; facility_id: number},
  useGlobalLoader: boolean,
  cancelToken?: CancelToken,
) {
  return await APIGet(APIUrl(AdminType.Customer, "/tee-sheet/lottery"), params, useGlobalLoader, cancelToken);
}

export async function CustomerPostLotteryRequest(
    params: IPostLotteryRequestParams,
    useGlobalLoader: boolean,
  ) {
    return await APIPost(APIUrl(AdminType.Customer, "/tee-sheet/lottery/request"), params, useGlobalLoader);
  }

  export async function CustomerGetLotteryTeeTimes(
    params: {facility_id: number, course_id: number; date: string; lottery_id: number, extended?: boolean; turn_tee_time?: boolean},
    useGlobalLoader: boolean,
    cancelToken?: CancelToken,
  ) {
    return await APIGet<Array<ITeeTime>>(APIUrl(AdminType.Customer, "/tee-sheet/lottery/teetimes"), params, useGlobalLoader, cancelToken);
  }